<template>
  <div class="appeal-wrapper">
    <div class="content_appeal">
      <!-- 订单信息 -->
      <div class="section">
        <div class="section-title">订单信息</div>
        <div class="order-info">
          <div class="row">
            <div class="label">运单号:</div>
            <div class="value">{{ appealInfo.orderCode || "--" }}</div>
          </div>
          <div class="row">
            <div class="label">实际承运人信息:</div>
            {{ appealInfo.vehicleLicense || "--" }}
            {{ appealInfo.driverName || "--" }}
            {{ appealInfo.driverPhone || "--" }}
          </div>

          <div class="row">
            <div class="label">路线:</div>
            <div class="value route">
              <span>{{
                appealInfo.shipperProvice +
                  appealInfo.shipperCity +
                  appealInfo.shipperArea +
                  appealInfo.shipperDetailAddress || "--"
              }}</span>
              <i class="el-icon-right" />
              <span>{{
                appealInfo.consigneeProvice +
                  appealInfo.consigneeCity +
                  appealInfo.consigneeArea +
                  appealInfo.consigneeDetailAddress || "--"
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section">
        <div class="section-title">首次驳回原因</div>
        <div class="order-info">
          <div>{{ appealInfo.authorizeCause || "--" }}</div>
        </div>
      </div> -->
      <!-- 申诉理由 -->
      <div v-if="!isDetail" class="section">
        <div class="section-title">
          申诉理由
          <span style="color: #409EFF;" v-if="appealInfo.authorizeCause"
            >(首次驳回原因：{{ appealInfo.authorizeCause }})</span
          >
        </div>
        <!-- button按钮组用于切换  appealTypeArr 不是单选项-->
        <el-button-group style="margin-bottom:15px;">
          <el-button
            @click="selectAppealType(item)"
            :type="AppealTypeValue == item ? 'primary' : 'default'"
            v-for="item in appealTypeArr"
            :key="item"
            >{{ item }}</el-button
          >
        </el-button-group>
        <div v-for="i in formArr" :key="i.type">
          <el-form
            v-if="AppealTypeValue == i.type"
            ref="formRef"
            :model="form"
            label-width="0"
          >
            <el-form-item prop="reasonText">
              <el-input
                type="textarea"
                v-model="i.reasonText"
                :rows="4"
                :disabled="isDetail"
                :placeholder="`请输入${i.type}申诉理由`"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>

            <!-- 申诉材料 -->
            <div class="section-subtitle">
              申诉材料：最多上传5张，推荐上传合同、回单、车辆ETC发票、过路记录等
            </div>
            <multipleUpload
              :required="false"
              :max-count="5"
              :disabled="isDetail"
              :img-list.sync="i.imgList"
              @totalSuccess="totalSuccess"
            ></multipleUpload>
          </el-form>
        </div>
      </div>
      <!-- v-else -->
      <div v-if="appealRecordArr.length">
        <div class="section-title">
          申诉记录
          <span style="color: #409EFF;" v-if="isDetail"
            >(首次驳回原因：{{ appealInfo.authorizeCause }})</span
          >
        </div>
        <AppealRecord :arr="appealRecordArr" />
      </div>
    </div>

    <div class="dialog-footer" v-if="!isDetail">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">
        确定提交
      </el-button>
    </div>
  </div>
</template>

<script>
import AppealRecord from "@/components/AppealRecord/index.vue";
import multipleUpload from "@/components/ImgUpload/multipleUpload.vue";
import { submitAppeal, queryOrderAppealList } from "@/api/transport";
import { template } from "xe-utils/methods";
export default {
  name: "appealOrder",
  props: {
    appealInfo: {
      type: Object,
      default: () => ({})
    },
    alertType: {
      type: String,
      default: ""
    }
  },
  components: { multipleUpload, AppealRecord },
  data() {
    return {
      form: {
        reasonText: ""
      },

      imgList: [],
      AppealTypeValue: "",
      formArr: [],
      priceSupportingMaterials: [],
      pathSupportingMaterials: [],
      otherSupportingMaterials: [],
      appealRecordArr: []
    };
  },
  watch: {
    appealInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getAppealDetail();

          let arr = this.appealInfo.appealType.split(",");
          if (arr.length) {
            this.AppealTypeValue = arr[0];
            // 将arr转换为指定的对象结构并赋值给formArr
            this.formArr = arr.map(type => ({
              type: type,
              reasonText: "",
              imgList: []
            }));
          }
        }
      },
      immediate: true,
      deep: true
    },
    alertType: {
      handler(newVal, oldVal) {
        if (newVal === "detail") {
        }
      },
      immediate: true
    }
  },
  computed: {
    appealTypeArr() {
      return this.appealInfo.appealType.split(",");
    },
    isDetail() {
      return this.alertType === "detail";
    }
  },
  methods: {
    getAppealDetail() {
      queryOrderAppealList({
        orderCode: this.appealInfo.code
      }).then(res => {
        if (res.status === 0) {
          this.appealRecordArr = res.data.records;
          // if (info) {
          //   this.formArr.forEach(item => {
          //     if (item.type === "运费异常") {
          //       item.reasonText = info.appealReasonPrice;
          //       item.imgList = info.priceSupportingMaterials;
          //     } else if (item.type === "其他异常") {
          //       item.reasonText = info.appealReasonOther;
          //       item.imgList = info.otherSupportingMaterials;
          //     } else if (item.type === "轨迹异常") {
          //       item.reasonText = info.appealReasonPath;
          //       item.imgList = info.pathSupportingMaterials;
          //     }
          //   });
          //   this.$forceUpdate();
          // }
        }
      });
    },
    selectAppealType(item) {
      this.AppealTypeValue = item;
    },
    totalSuccess(obj) {
      console.log("一共的obj=========", obj.Img);
      this.imgList = obj.Img;
      this.formArr.forEach((item, index) => {
        if (this.AppealTypeValue === "运费异常") {
          item.imgList = obj.Img;
        } else if (this.AppealTypeValue === "轨迹异常") {
          item.imgList = obj.Img;
        } else if (this.AppealTypeValue === "其他异常") {
          item.imgList = obj.Img;
        }
      });
      this.$forceUpdate();
      // this.formArr.forEach(item => {
      //   if (item.type === "运费异常") {
      //     item.imgList = obj.Img;
      //   } else if (item.type === "轨迹异常") {
      //     item.imgList = obj.Img;
      //   } else if (item.type === "其他异常") {
      //     item.imgList = obj.Img;
      //   }
      // });
    },

    handleClose() {
      this.$emit("close");
    },
    async submit() {
      let data = {
        orderCode: this.appealInfo.code,
        appealType: this.appealInfo.appealType
      };
      let type = "";
      this.formArr.forEach(item => {
        if (item.type === "运费异常") {
          data.appealReasonPrice = item.reasonText;
          data.priceSupportingMaterials = item.imgList;
          if (!item.reasonText) {
            type = "请输入运费异常申诉理由";
          }
          // else if (item.imgList.length === 0) {
          //   type = "请上传运费异常申诉材料";
          // }
        }
        if (item.type === "其他异常") {
          data.appealReasonOther = item.reasonText;
          data.otherSupportingMaterials = item.imgList;
          if (!item.reasonText && !type) {
            type = "请输入其他异常申诉理由";
          }
          //  else if (item.imgList.length === 0 && !type) {
          //   type = "请上传其他异常申诉材料";
          // }
        }
        if (item.type === "轨迹异常") {
          data.appealReasonPath = item.reasonText;
          data.pathSupportingMaterials = item.imgList;
          if (!item.reasonText && !type) {
            type = "请输入轨迹异常申诉理由";
          } else if (item.imgList.length === 0 && !type) {
            type = "请上传轨迹异常申诉材料";
          }
        }
      });
      if (type) {
        this.$message({
          message: type,
          type: "warning"
        });
        return;
      }

      let res = await submitAppeal(data);
      if (res.status === 0) {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.handleClose();
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content_appeal {
  height: 620px;
  overflow-y: auto;
}
.appeal-wrapper {
  position: relative;
  height: 100%;
}
.section {
  margin-bottom: 18px;
}
.section-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.section-subtitle {
  color: #666;
  margin: 8px 0 12px;
}
.order-info {
  background: #f7f8fa;
  padding: 12px;
  border-radius: 6px;
}
.order-info .row {
  display: flex;
  margin: 4px 0;
}
.order-info .label {
  width: 60px;
  color: #666;
  text-align: right;
  margin-right: 10px;
}
.order-info .value {
  flex: 1;
}
.order-info .route {
  display: flex;
  align-items: center;
}
.order-info .route i {
  margin: 0 6px;
}
.dialog-footer {
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #fff;
  padding: 15px 20px;
  width: 100%;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  height: 50px;
}
</style>
